import ClueyCoachTutor from './ClueyCoachTutor';

export default ClueyCoachTutor;
